import React, { useState } from "react";
import classes from "./transaction-history-container.module.css";
import NewToolTip from "../NewToolTip";
import { dateFilterList } from "../../services/constants";
import cx from "classnames";
import { useRouter } from "next/router";
import { Routes } from "../../routes/RouteConstants";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";

const DateFilter = ({ dateFilter }) => {
  const router = useRouter();
  const { query } = router;

  const [showDateTip, setDateTip] = useState(false);

  function openDateTip() {
    setDateTip(true);
    LogService.log(CREDIT_EVENTS.TH_DATE_FILTER_CLICKED);
  }

  function handleCloseTip() {
    setDateTip(false);
  }

  function onDateSelect(e, date) {
    e.stopPropagation();
    const queryParams = { ...query, dateId: date, page: 1 };
    router
      .push({
        pathname: Routes.TRANSACTION_HISTORY,
        query: queryParams
      })
      .then(() => {
        handleCloseTip();
      });
    LogService.log(CREDIT_EVENTS.TH_DATE_FILTER_SELECTED, { date });
  }

  const remainingDateList = dateFilterList.filter(
    date => date.value !== dateFilter
  );

  const selectedDate =
    dateFilterList.find(item => item.value === dateFilter)?.label || "";

  return (
    <>
      <div className={classes.dateFilter} onClick={openDateTip}>
        <img
          src="/hire/date-filter.svg"
          alt="date-filter-icon"
          height={13}
          width={13}
          className={classes.dateIcon}
        />

        {selectedDate}
        <img
          src="/hire/filter-arrow.svg"
          alt="filter-arrow-icon"
          height={16}
          width={16}
          className={classes.filterArrow}
        />
        {showDateTip ? (
          <NewToolTip
            rootClass={classes.dateFilterToolTip}
            tipClass={classes.tipClass}
            handleClose={handleCloseTip}
            keepScrollEvent={false}
            tipUrl={"/hire/tipUp.svg"}
            isClose={false}
          >
            {remainingDateList.map((date, index) => {
              return (
                <div
                  key={index}
                  className={cx(
                    index !== remainingDateList.length - 1 && classes.border,
                    classes.dateTipContent
                  )}
                  onClick={e => onDateSelect(e, date.value)}
                >
                  {date.label}
                </div>
              );
            })}
          </NewToolTip>
        ) : null}
      </div>
    </>
  );
};

export default DateFilter;
